import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar";

function Disclaimer() {
  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">Disclaimer</h2>
          <article className="article">
            <div className="article-inner">
              <p>
                The apkdownloads.net web site (the "Site") is an online information
                service provided by APK Downloads, subject to your compliance with
                the terms and conditions set forth below. Please read this document
                carefully before accessing or using the Site. We reserve the right
                to modify these terms at any time, with changes taking effect
                immediately upon posting.
              </p>

              <h2>1. Copyright, Licenses and Idea Submissions</h2>
              <p>
                The entire contents of the Site are protected by international
                copyright and trademark laws. You may not modify, copy, reproduce,
                republish, upload, post, transmit, or distribute site materials
                including text, graphics, code, or software. Limited printing and
                downloading for personal, non-commercial use is permitted provided
                the copyright notices remain intact. You grant the Site a
                non-exclusive, royalty-free, worldwide, perpetual license to use any
                materials you submit to public areas or by email.
              </p>

              <h2>2. Use of the Site</h2>
              <p>
                The Site does not operate, control, or endorse third-party
                information, products, or services. We cannot and do not guarantee
                or warrant that files available for downloading through the Site
                will be free of infection or viruses. We provide the Site and
                related information "as is" and make no warranties regarding service
                quality, merchandise, or fitness for a particular purpose. You
                assume total responsibility and risk for your use of the Site and
                the Internet.
              </p>

              <h2>Limitation of Liability</h2>
              <p>
                We will not be liable for incidental, consequential, or indirect
                damages, including lost profits or business interruption, regardless
                of prior notice of potential damages.
              </p>

              <h2>3. Indemnification</h2>
              <p>
                You agree to indemnify and defend the platform against losses,
                expenses, damages, and costs resulting from violations of this
                agreement.
              </p>

              <h2>4. Third Party Rights</h2>
              <p>
                Officers, directors, employees, agents, and third-party providers
                may enforce these provisions directly against you.
              </p>

              <h2>5. Termination</h2>
              <p>
                Either party may terminate this agreement without notice for any
                reason. Certain provisions survive termination.
              </p>

              <h2>6. Miscellaneous</h2>
              <p>
                This agreement is governed by the laws of India. Legal actions must
                be brought in Indian courts and any claim must commence within one
                year.
              </p>
            </div>
          </article>
        </Col>
        <Col lg={4}><Sidebar /></Col>
      </Row>
    </Container>
  );
}

export default Disclaimer;
